// Theme utilities and constants (extracted from ThemeContext to satisfy react-refresh rule)

export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
  SYSTEM: "system",
};

export const THEME_STORAGE_KEY = "gg-theme";

export function getSystemTheme() {
  if (typeof window === "undefined") return "dark";
  return window.matchMedia("(prefers-color-scheme: light)").matches
    ? "light"
    : "dark";
}

export function getStoredTheme() {
  if (typeof window === "undefined") return THEMES.SYSTEM;

  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored && Object.values(THEMES).includes(stored)) {
      return stored;
    }
  } catch (error) {
    console.warn("Failed to read theme from localStorage:", error);
  }

  return THEMES.SYSTEM;
}

export function applyTheme(theme) {
  if (typeof window === "undefined") return;

  const root = window.document.documentElement;

  // Remove existing theme classes
  root.classList.remove("light", "dark");

  // Add new theme class
  root.classList.add(theme);

  // Update color-scheme for better browser defaults
  root.style.colorScheme = theme;
}
